requirejs(['jquery', 'form/sort', 'lib/jquery.richtext', 'utils/common'], function ($, Sort) {
	
	$(document).ready(function () {
		
		if($('#list').exists()) {
			
			new Sort({
				element : $('#list ul'),
				params : $("#list").data('params')
			});
			
		}
		
		
		if($('textarea.html').exists()) {
			$('textarea.html').richtext({
				fileUpload: true,
				advanced: true
			});
		}
		
		if($('.linking').exists()) {
			
			var as = $('.linking a.link').click(function (e) {
				e.preventDefault();
				var url = $(this).attr('href');
				
				if(url.indexOf(".php") > 0) 
					url = url.substring(url.indexOf(".php") + 4);
				
				$('#Menu_url').val(url);
			});
			
		}
	
	});
});
define("cms", function(){});

